export const styles = theme => ({
    root: {
        width: "100%",
        justifyContent: "space-between",
        backgroundColor: "#009",
        height: "33px",
    },
    rootMobile: {
        width: "100%",
        justifyContent: "space-between",
        backgroundColor: "#009",
        height: "53px",
    },
    navElements: {
        maxWidth: 1200,
        margin: "0 auto",
        color: "white",
        justifyContent: "space-between",
        display: "flex",
        fontFamily: "newsGothic_light,Arial,Verdana,Helvetica,sans-serif",
        "& ul": {
            listStyleType: "none",
            margin: "0px auto",
            display: "flex",
            padding: 0
        },
        "& li": {
            display: "inline-block",
            margin: "0px 10px",
        },
        fontWeight: "bold" as const,
    },
    link: {
        textDecoration: "none",
        fontSize: "1rem",
        color: "white",
        "&:hover": {
            textDecoration: "underline solid white 2px",
        },
        display: "flex",
        alignItems: "center",
        padding: "6px 0px 5px 0px"
    },
    notification: {
        color: "white",
        backgroundColor: '#33ADFF',
        fontSize: "1rem",
        padding: "6px 0px 5px 0px"
    }
});
